// extracted by mini-css-extract-plugin
module.exports = {"root":"File_root__331HM","iframe":"File_iframe__he4-_"};